/* ============================================================
   ILEV - ANIVERSARIO ANTICASPA - Carrito  v10
   LOGICA del carrito.
   - Textos, productos, HITOS y REGLA en assets/ilev-carrito-config.js
   - Ajustes de color/tamano en assets/ilev-carrito-fix.js
   v9  (05-sep): el regalo ya no suma para el envio gratis.
   v10 (06-sep): barra de progreso con VARIOS HITOS (envio gratis +
                 regalo por monto), estilo minimalista con nodos.
   ============================================================ */

var ILEV_ACTIVO = (typeof window.ILEV_ACTIVO !== 'undefined') ? window.ILEV_ACTIVO : true;

var ILEV_IDS = window.ILEV_IDS || {
  duo: 44077689536693, tonico: 42481091084469, bomba: 43620701995189, shampoo: 44971738235061
};

var ILEV_CFG = window.ILEV_CFG || {
  umbral: 40000,
  hitos: [
    { monto: 40000,  n: 'Envío gratis',             i: 'truck', falta: 'Te faltan <strong>{x}</strong> para conseguir el envío gratuito!' },
    { monto: 130000, n: 'Shampoo Anticaída gratis', i: 'gift',  falta: 'Te faltan <strong>{x}</strong> para llevarte el <strong>Shampoo Anticaída</strong> de regalo!' }
  ],
  regaloProductId: 10572843647157,
  regaloVariantId: 53104403873973,
  regalosExcluidos: [53104403873973],
  maxRegalo: 1,
  msgTope: 'El regalo es 1 por persona, para que alcance para todos.',
  tituloConDato: 'El 86% de los clientes también se llevó:',
  tituloGenerico: 'Completa tu rutina',
  txtFalta: 'Te faltan <strong>{x}</strong> para conseguir el envío gratuito!',
  txtVacio: 'Suma tu rutina y consigue el <strong>envío gratuito</strong>',
  txtLogrado: '¡Conseguiste el <strong>envío gratuito</strong>!',
  txtTodo: '¡Desbloqueaste todo: <strong>envío gratis</strong> + <strong>Shampoo Anticaída</strong> de regalo!',
  txtTarjeta: '+ Envío gratis',
  minResenas: 5,
  trust: [
    { i: 'truck', t: 'Envío gratis $40.000' },
    { i: 'shield', t: 'Garantía de 90 días' },
    { i: 'lock', t: 'Pago 100% seguro' }
  ],
  productos: {
    44077689536693: { n: 'DUO Anticaida - Tonico + Bomba', p: 49800, r: 4.7, nr: 127, img: 'ilevroutine-duo-portada-1_200x.jpg?v=1788611404' },
    42481091084469: { n: 'Tonico Anticaida',               p: 23900, r: 4.5, nr: 446, img: 'ilevroutine-tonico-portada-1_200x.jpg?v=1783023331' },
    43620701995189: { n: 'Bomba Nutricional',              p: 25900, r: 4.9, nr: 88,  img: 'ilevroutine-bomba-portada-1_200x.jpg?v=1783023237' },
    44971738235061: { n: 'Shampoo Anticaida en barra 70 g',p: 16990, r: 4.8, nr: 10,  img: 'ilevroutine-shampoo-portada-1_200x.jpg?v=1783023012' }
  },
  extras: [
    { id: 45474721726645, n: 'Tonico de Barba',     p: 28900, r: 4.0, nr: 1,  img: 'ilevroutine-barba-portada-1_200x.jpg?v=1783022884' },
    { id: 42480528785589, n: 'Serum Antiquiebre',   p: 20900, r: 4.9, nr: 14, img: 'ilevroutine-serum-portada-1_200x.jpg?v=1783022884' },
    { id: 53216576405685, n: 'Anticaspa 70 g (XL)', p: 17990, r: 0,   nr: 0,  img: '' }
  ]
};

/* regla de respaldo, por si el config no cargara */
var ILEV_REGLA = window.ILEV_REGLA || function (tiene, ID) {
  var duo = tiene(ID.duo), ton = tiene(ID.tonico), bom = tiene(ID.bomba), sha = tiene(ID.shampoo);
  var out = [];
  if (duo || (ton && bom)) { /* rutina completa */ }
  else if (ton) out.push(ID.bomba, ID.duo);
  else if (bom) out.push(ID.tonico, ID.duo);
  else out.push(ID.duo, ID.tonico, ID.bomba);
  if (!sha) out.push(ID.shampoo);
  return out;
};

(function () {
  'use strict';
  if (!ILEV_ACTIVO) return;

  var CDN = 'https://cdn.shopify.com/s/files/1/0619/8296/5941/files/';
  var ocupado = false;

  var ICON = {
    truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M1 3h13v13H1zM14 8h4l3 3v5h-7z"/><circle cx="5.5" cy="18.5" r="2"/><circle cx="17.5" cy="18.5" r="2"/></svg>',
    gift: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M5 12v8a1 1 0 001 1h12a1 1 0 001-1v-8M12 8v13"/><path d="M12 8S10.5 3.5 8 3.5A2.2 2.2 0 008 8zM12 8s1.5-4.5 4-4.5A2.2 2.2 0 0116 8z"/></svg>',
    shield: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M12 2l8 3v6c0 5-3.4 9.4-8 11-4.6-1.6-8-6-8-11V5z"/></svg>',
    lock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><rect x="4" y="10" width="16" height="11" rx="2"/><path d="M8 10V7a4 4 0 018 0v3"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12.5l5.5 5.5L20 6.5"/></svg>',
    prev: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg>',
    next: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg>'
  };

  function pesos(c) { return '$' + Math.round(c / 100).toLocaleString('es-CL'); }
  function miles(v) { return '$' + v.toLocaleString('es-CL'); }

  /* ============================================================
     Subtotal que el cliente REALMENTE paga.
     Los regalos entran al carrito con precio y el descuento
     automatico recien los deja en $0 en el checkout, asi que
     /cart.js los sigue sumando. Si no los restamos, la barra
     canta "envio gratis" con menos plata real de la que hay.
     ============================================================ */
  function esRegalo(vid) {
    var lista = ILEV_CFG.regalosExcluidos || [ILEV_CFG.regaloVariantId];
    return lista.indexOf(vid) !== -1;
  }

  function subtotalReal(c) {
    var sub = c.items_subtotal_price;
    for (var i = 0; i < c.items.length; i++) {
      var it = c.items[i];
      if (esRegalo(it.variant_id)) {
        sub -= (typeof it.final_line_price === 'number') ? it.final_line_price : it.line_price;
      }
    }
    return sub > 0 ? sub : 0;
  }

  function estrellas(s) {
    var min = ILEV_CFG.minResenas || 5;
    if (!s.nr || s.nr < min || !s.r) return '';
    var llenas = Math.round(s.r);
    var h = '<span class="ilev-card__stars">';
    for (var i = 1; i <= 5; i++) h += '<span class="' + (i <= llenas ? 'on' : '') + '">★</span>';
    return h + '<span class="ilev-card__nr">(' + s.nr + ')</span></span>';
  }

  function cart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function refrescar() {
    if (typeof window.refreshCart === 'function') {
      window.refreshCart();
      setTimeout(pintar, 500);
    } else { location.reload(); }
  }

  function agregar(id, boton) {
    if (boton) { boton.disabled = true; boton.classList.add('ilev-add--load'); }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) { return r.json(); })
      .then(function () { refrescar(); })
      .catch(function () {
        if (boton) { boton.disabled = false; boton.classList.remove('ilev-add--load'); }
        aviso('No pudimos agregarlo. Inténtalo de nuevo.');
      });
  }

  function cambiar(linea, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: linea, quantity: qty })
    }).then(function () { refrescar(); });
  }

  function aviso(txt) {
    var p = document.getElementById('ilev-aviso');
    if (p) p.remove();
    var d = document.createElement('div');
    d.id = 'ilev-aviso'; d.className = 'ilev-aviso'; d.textContent = txt;
    document.body.appendChild(d);
    setTimeout(function () { d.classList.add('ilev-aviso--fuera'); }, 3500);
    setTimeout(function () { if (d.parentNode) d.remove(); }, 4200);
  }

  function tope(c) {
    for (var i = 0; i < c.items.length; i++) {
      if (c.items[i].variant_id === ILEV_CFG.regaloVariantId && c.items[i].quantity > ILEV_CFG.maxRegalo) {
        aviso(ILEV_CFG.msgTope);
        cambiar(i + 1, ILEV_CFG.maxRegalo);
        return true;
      }
    }
    return false;
  }

  function badge() {
    var items = document.querySelectorAll('.cart-item[data-product-id="' + ILEV_CFG.regaloProductId + '"]');
    for (var i = 0; i < items.length; i++) {
      var el = items[i];
      if (el.querySelector('.ilev-badge')) continue;
      var t = el.querySelector('.cart-item__title');
      if (!t) continue;
      var b = document.createElement('span');
      b.className = 'ilev-badge'; b.textContent = 'REGALO';
      t.parentNode.insertBefore(b, t);
      var q = el.querySelector('product-quantity');
      if (q) q.style.display = 'none';
    }
  }

  /* usa la regla definida en el config */
  function elegirSugerencias(idsEnCarrito) {
    var tiene = function (id) { return idsEnCarrito.indexOf(id) !== -1; };
    var lista = ILEV_REGLA(tiene, ILEV_IDS) || [];

    var out = [];
    lista.forEach(function (id) {
      var p = ILEV_CFG.productos[id];
      if (p) out.push({ id: id, n: p.n, p: p.p, r: p.r, nr: p.nr, img: p.img });
    });
    ILEV_CFG.extras.forEach(function (e) { if (!tiene(e.id)) out.push(e); });
    return out;
  }

  /* ============================================================
     BARRA DE PROGRESO CON HITOS
     Los hitos se reparten equiespaciados a lo largo del riel
     (centro de cada tramo), igual que la referencia. El relleno
     avanza por tramos: entre hito y hito interpola lineal.
     ============================================================ */
  function hitos() {
    var H = ILEV_CFG.hitos;
    if (H && H.length) return H;
    return [{ monto: ILEV_CFG.umbral, n: 'Envío gratis', i: 'truck', falta: ILEV_CFG.txtFalta }];
  }

  function htmlBarra(c) {
    var H = hitos();
    var n = H.length;
    var sub = subtotalReal(c);

    /* centro de cada tramo: 1 hito -> 50% ; 2 -> 25% y 75% ; 3 -> 16,5% 50% 83,5% */
    var pos = [];
    for (var i = 0; i < n; i++) pos.push(((i + 0.5) / n) * 100);

    /* cuanto se llena y cual es el siguiente hito pendiente */
    var fill = 100, sig = -1;
    for (i = 0; i < n; i++) {
      var m = H[i].monto * 100;
      if (sub >= m) continue;
      var mAnt = (i === 0) ? 0 : H[i - 1].monto * 100;
      var pAnt = (i === 0) ? 0 : pos[i - 1];
      var t = (m - mAnt) > 0 ? (sub - mAnt) / (m - mAnt) : 1;
      t = Math.max(0, Math.min(1, t));
      fill = pAnt + (pos[i] - pAnt) * t;
      sig = i;
      break;
    }

    var todo = (sig === -1);
    var txt;
    if (todo) txt = ILEV_CFG.txtTodo || ILEV_CFG.txtLogrado;
    else if (sub === 0 && sig === 0) txt = ILEV_CFG.txtVacio;
    else txt = (H[sig].falta || ILEV_CFG.txtFalta).replace('{x}', pesos(H[sig].monto * 100 - sub));

    var h = '<div class="ilev-prog ilev-prog--h' + (todo ? ' ilev-prog--ok' : '') + '">' +
            '<p class="ilev-prog__txt">' + txt + '</p>' +
            '<div class="ilev-hitos">' +
              '<div class="ilev-hitos__riel"><span class="ilev-hitos__fill" style="width:' + fill.toFixed(1) + '%"></span></div>';

    for (i = 0; i < n; i++) {
      var logrado = sub >= H[i].monto * 100;
      h += '<div class="ilev-hito' + (logrado ? ' ilev-hito--on' : '') + '" style="left:' + pos[i].toFixed(1) + '%">' +
             '<span class="ilev-hito__ico">' + (logrado ? ICON.check : (ICON[H[i].i] || ICON.gift)) + '</span>' +
             '<span class="ilev-hito__n">' + H[i].n + '</span>' +
             '<span class="ilev-hito__p">' + miles(H[i].monto) + '</span>' +
           '</div>';
    }

    return h + '</div></div>';
  }

  function htmlSug(c) {
    var U = ILEV_CFG.umbral * 100;
    var sub = subtotalReal(c);
    var ok = (U - sub) <= 0;

    var ids = c.items.map(function (i) { return i.variant_id; });
    var libres = elegirSugerencias(ids);
    if (!libres.length) return '';

    var I = ILEV_IDS;
    var conDato = [I.duo, I.tonico, I.bomba];
    var aplicaDato = libres.slice(0, 3).some(function (s) { return conDato.indexOf(s.id) !== -1; });
    var titulo = aplicaDato ? ILEV_CFG.tituloConDato : ILEV_CFG.tituloGenerico;

    var h = '<p class="ilev-sug__tit">' + titulo + '</p>' +
            '<div class="ilev-sug__wrap">' +
              '<button type="button" class="ilev-arrow ilev-arrow--prev ilev-arrow--off" id="ilev-prev" aria-label="Anterior">' + ICON.prev + '</button>' +
              '<div class="ilev-sug__lista" id="ilev-slider">';
    libres.forEach(function (s) {
      var cruza = !ok && (sub + s.p * 100) >= U;
      var img = s.img ? '<img src="' + CDN + s.img + '" alt="" loading="lazy">'
                      : '<span class="ilev-card__ph">ILEV</span>';
      h += '<div class="ilev-card">' +
             '<div class="ilev-card__img">' + img + '</div>' +
             '<div class="ilev-card__info">' +
               estrellas(s) +
               '<span class="ilev-card__n">' + s.n + '</span>' +
               '<span class="ilev-card__p">' + miles(s.p) + '</span>' +
               (cruza ? '<span class="ilev-card__ok">' + ILEV_CFG.txtTarjeta + '</span>' : '') +
             '</div>' +
             '<button type="button" class="ilev-add" data-v="' + s.id + '" aria-label="Agregar ' + s.n + '">+</button>' +
           '</div>';
    });
    h += '</div>' +
         '<button type="button" class="ilev-arrow ilev-arrow--next" id="ilev-next" aria-label="Siguiente">' + ICON.next + '</button>' +
         '</div>';
    return h;
  }

  function trust() {
    var pie = document.querySelector('#site-cart-sidebar .sidebar__footer');
    if (!pie) return;
    var ya = document.getElementById('ilev-trust');
    if (ya) { pie.appendChild(ya); return; }
    var d = document.createElement('div');
    d.id = 'ilev-trust'; d.className = 'ilev-trust';
    var h = '';
    ILEV_CFG.trust.forEach(function (b) { h += '<span class="ilev-trust__i">' + ICON[b.i] + b.t + '</span>'; });
    d.innerHTML = h;
    pie.appendChild(d);
  }

  function enlazar(caja, itemsCarrito) {
    var bs = caja.querySelectorAll('.ilev-add');
    for (var i = 0; i < bs.length; i++) {
      bs[i].addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        agregar(Number(this.dataset.v), this);
      });
    }

    var slider = caja.querySelector('#ilev-slider');
    if (!slider) return;
    slider.style.setProperty('--ilev-card-w', itemsCarrito <= 1 ? '58%' : '78%');

    var prev = caja.querySelector('#ilev-prev');
    var next = caja.querySelector('#ilev-next');

    function paso() {
      var c1 = slider.children[0];
      return c1 ? c1.getBoundingClientRect().width + 8 : 200;
    }
    function actualizarFlechas() {
      var hayScroll = slider.scrollWidth > slider.clientWidth + 4;
      var alInicio = slider.scrollLeft <= 4;
      var alFinal = slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 4;
      if (prev) prev.classList.toggle('ilev-arrow--off', alInicio || !hayScroll);
      if (next) next.classList.toggle('ilev-arrow--off', alFinal || !hayScroll);
    }
    function scrollSuave(delta) {
      var snapPrevio = slider.style.scrollSnapType;
      slider.style.scrollSnapType = 'none';
      var inicio = slider.scrollLeft;
      var maximo = slider.scrollWidth - slider.clientWidth;
      var destino = Math.max(0, Math.min(maximo, inicio + delta));
      var real = destino - inicio;
      var t0 = null, dur = 300;
      function frame(t) {
        if (t0 === null) t0 = t;
        var p = Math.min(1, (t - t0) / dur);
        var e = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
        slider.scrollLeft = inicio + real * e;
        if (p < 1) requestAnimationFrame(frame);
        else { slider.style.scrollSnapType = snapPrevio; actualizarFlechas(); }
      }
      requestAnimationFrame(frame);
    }

    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); scrollSuave(-paso()); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); scrollSuave(paso()); });
    slider.addEventListener('scroll', actualizarFlechas, { passive: true });
    setTimeout(actualizarFlechas, 100);
    window.addEventListener('resize', actualizarFlechas);
  }

  function pintar() {
    if (ocupado) return;
    ocupado = true;
    cart().then(function (c) {
      if (tope(c)) { ocupado = false; return; }
      var cf = document.querySelector('cart-form');

      var barra = document.querySelector('shipping-notice');
      if (!barra && cf) {
        barra = document.createElement('shipping-notice');
        barra.className = 'cart-notice';
        cf.insertBefore(barra, cf.firstChild);
      }
      if (barra) barra.innerHTML = htmlBarra(c);

      var sug = document.getElementById('ilev-sug');
      if (!sug && cf && cf.parentNode) {
        sug = document.createElement('div');
        sug.id = 'ilev-sug'; sug.className = 'ilev-sug';
        cf.parentNode.insertBefore(sug, cf.nextSibling);
      }
      if (sug) {
        var contenido = htmlSug(c);
        sug.innerHTML = contenido;
        sug.style.display = contenido ? '' : 'none';
        if (contenido) enlazar(sug, c.items.length);
      }

      badge();
      trust();
      ocupado = false;
    }).catch(function () { ocupado = false; });
  }

  if (typeof customElements.get('shipping-notice') === 'undefined') {
    customElements.define('shipping-notice', class extends HTMLElement {
      connectedCallback() { setTimeout(pintar, 60); }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pintar);
  else pintar();

  document.addEventListener('cart-updated', function () { setTimeout(pintar, 250); }, true);

  var f0 = window.fetch;
  window.fetch = function () {
    var u = arguments[0];
    var esCart = typeof u === 'string' && u.indexOf('/cart') !== -1 &&
                 u.indexOf('/cart.js') === -1 && u.indexOf('section_id') === -1;
    return f0.apply(this, arguments).then(function (r) {
      if (esCart) setTimeout(pintar, 400);
      return r;
    });
  };

  var obs = new MutationObserver(function () {
    clearTimeout(window.__ilevT);
    window.__ilevT = setTimeout(function () { badge(); trust(); }, 250);
  });
  if (document.body) obs.observe(document.body, { childList: true, subtree: true });

  var css = document.createElement('style');
  css.id = 'ilev-estilos';
  css.textContent =
    '#site-cart-sidebar .sidebar__body{min-width:0;max-width:100%;overflow-x:hidden}' +
    '#site-cart-sidebar .sidebar__body>.cart-form{min-width:0;max-width:100%}' +
    '#ilev-sug{width:100%;max-width:100%;min-width:0;box-sizing:border-box}' +
    '#ilev-slider{width:100%;max-width:100%;min-width:0}' +
    '#site-cart-sidebar .sidebar__header{padding-top:14px!important;padding-bottom:10px!important}' +
    '#site-cart-sidebar .sidebar__title{font-size:17px!important;line-height:1.2!important}' +

    '.ilev-prog{background:#f2f8fa;border:1px solid #B6DCE1;border-radius:12px;padding:13px 15px}' +
    '.ilev-prog--casi{background:#fff8ec;border-color:#f0c987}' +
    '.ilev-prog__txt{margin:0 0 9px;font-size:13.5px;line-height:1.35;color:#4B384C}' +
    '.ilev-prog__riel{height:7px;background:rgba(75,56,76,.12);border-radius:99px;overflow:hidden}' +
    '.ilev-prog__riel span{display:block;height:100%;background:#4B384C;border-radius:99px;transition:width .5s cubic-bezier(.4,0,.2,1)}' +

    '.ilev-prog.ilev-prog--h{background:transparent;border:0;border-radius:0;padding:2px 0 0;box-shadow:none}' +
    '.ilev-prog.ilev-prog--h .ilev-prog__txt{margin:0 0 14px;font-size:14.5px;line-height:1.35;color:#4B384C;letter-spacing:-.1px}' +
    '.ilev-prog.ilev-prog--h .ilev-prog__txt strong{font-weight:700}' +
    '.ilev-hitos{position:relative;height:62px;margin:0 4px}' +
    '.ilev-hitos__riel{position:absolute;left:0;right:0;top:11px;height:5px;background:rgba(75,56,76,.13);border-radius:99px;overflow:hidden}' +
    '.ilev-hitos__fill{display:block;height:100%;width:0;background:#4B384C;border-radius:99px;transition:width .55s cubic-bezier(.4,0,.2,1)}' +
    '.ilev-hito{position:absolute;top:0;transform:translateX(-50%);width:96px;display:flex;flex-direction:column;align-items:center;text-align:center;gap:2px}' +
    '.ilev-hito__ico{width:27px;height:27px;border-radius:50%;background:#eceff2;box-shadow:0 0 0 3px #fff;display:flex;align-items:center;justify-content:center;color:rgba(75,56,76,.42);margin-bottom:4px;transition:background .3s,color .3s}' +
    '.ilev-hito__ico svg{width:14px;height:14px;display:block}' +
    '.ilev-hito--on .ilev-hito__ico{background:#4B384C;color:#fff}' +
    '.ilev-hito__n{font-size:11.5px;line-height:1.2;color:rgba(75,56,76,.72);min-height:28px;display:flex;align-items:flex-start;justify-content:center}' +
    '.ilev-hito--on .ilev-hito__n{color:#4B384C}' +
    '.ilev-hito__p{font-size:12px;font-weight:700;line-height:1.2;color:#4B384C}' +
    '@media(max-width:400px){.ilev-hito{width:88px}.ilev-hito__n,.ilev-hito__p{font-size:11px}}' +

    '.ilev-sug{margin:14px 0 6px;padding-top:13px;border-top:1px solid rgba(75,56,76,.12)}' +
    '.ilev-sug__tit{margin:0 0 10px;font-size:11px;font-weight:700;letter-spacing:.7px;text-transform:uppercase;color:rgba(75,56,76,.62);line-height:1.35}' +
    '.ilev-sug__wrap{position:relative}' +
    '.ilev-arrow{position:absolute;top:50%;transform:translateY(-50%);z-index:3;width:32px;height:32px;display:flex;align-items:center;justify-content:center;padding:0;background:#fff;color:#4B384C;border:1px solid rgba(75,56,76,.18);border-radius:50%;cursor:pointer;box-shadow:0 2px 8px rgba(0,0,0,.12);transition:opacity .2s,visibility .2s,background .18s}' +
    '.ilev-arrow svg{width:15px;height:15px}' +
    '.ilev-arrow:hover{background:#f2f8fa}' +
    '.ilev-arrow--prev{left:-8px}' +
    '.ilev-arrow--next{right:-8px}' +
    '.ilev-arrow--off{opacity:0;visibility:hidden;pointer-events:none}' +
    '.ilev-sug__lista{display:flex;gap:8px;overflow-x:auto;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;scrollbar-width:none;padding-bottom:2px}' +
    '.ilev-sug__lista::-webkit-scrollbar{display:none}' +
    '.ilev-card{flex:0 0 var(--ilev-card-w,58%);scroll-snap-align:start;display:flex;gap:9px;align-items:center;padding:9px;background:#fff;border:1px solid rgba(75,56,76,.14);border-radius:10px;box-sizing:border-box}' +
    '.ilev-card__img{flex:0 0 48px;width:48px;height:48px;border-radius:7px;overflow:hidden;background:#f7fbfc;display:flex;align-items:center;justify-content:center}' +
    '.ilev-card__img img{width:100%;height:100%;object-fit:contain;padding:3px;display:block}' +
    '.ilev-card__ph{font-size:10px;font-weight:700;letter-spacing:1px;color:#B6DCE1}' +
    '.ilev-card__info{flex:1;display:flex;flex-direction:column;gap:1px;min-width:0}' +
    '.ilev-card__stars{display:flex;align-items:center;gap:1px;line-height:1;margin-bottom:1px}' +
    '.ilev-card__stars>span{font-size:9px;color:rgba(75,56,76,.2)}' +
    '.ilev-card__stars>span.on{color:#f0a500}' +
    '.ilev-card__nr{font-size:9.5px;color:rgba(75,56,76,.55);margin-left:3px}' +
    '.ilev-card__n{font-size:12px;font-weight:600;color:#4B384C;line-height:1.22;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}' +
    '.ilev-card__p{font-size:12px;color:rgba(75,56,76,.72)}' +
    '.ilev-card__ok{font-size:10px;font-weight:600;color:#3f9e5c;line-height:1.2}' +
    '.ilev-add{flex:0 0 30px;width:30px;height:30px;display:flex;align-items:center;justify-content:center;font-size:19px;line-height:1;font-family:inherit;color:#fff;background:#4B384C;border:0;border-radius:50%;cursor:pointer;transition:opacity .18s}' +
    '.ilev-add:hover{opacity:.85}' +
    '.ilev-add--load{opacity:.45;pointer-events:none}' +
    '#site-cart-sidebar .sidebar__footer{padding-top:12px!important;padding-bottom:14px!important}' +
    '#site-cart-sidebar .sidebar__footer .cart__total{margin-bottom:4px!important}' +
    '#site-cart-sidebar .sidebar__footer .cart__total strong{font-size:26px!important;line-height:1.15!important}' +
    '#site-cart-sidebar .sidebar__footer .cart__total span{font-size:13px!important}' +
    '#site-cart-sidebar .sidebar__footer .cart__shipping{font-size:11.5px!important;margin-bottom:8px!important}' +
    '#site-cart-sidebar .sidebar__footer .button{padding-top:11px!important;padding-bottom:11px!important;font-size:14px!important}' +
    '.ilev-trust{display:flex;flex-wrap:nowrap;gap:10px;justify-content:center;margin-top:11px;padding-top:10px;border-top:1px solid rgba(75,56,76,.1)}' +
    '.ilev-trust__i{display:flex;align-items:center;gap:4px;font-size:10px;color:rgba(75,56,76,.68);line-height:1.15;white-space:nowrap}' +
    '.ilev-trust__i svg{width:12px;height:12px;flex:0 0 12px}' +
    '.ilev-badge{display:inline-block;background:#4B384C;color:#fff;font-size:10px;font-weight:700;letter-spacing:.6px;padding:2px 7px;border-radius:4px;margin-bottom:5px}' +
    '.ilev-aviso{position:fixed;left:50%;bottom:26px;transform:translateX(-50%);background:#4B384C;color:#fff;padding:12px 20px;border-radius:10px;font-size:13.5px;max-width:88vw;text-align:center;z-index:99999;box-shadow:0 6px 24px rgba(0,0,0,.22);transition:opacity .5s,transform .5s}' +
    '.ilev-aviso--fuera{opacity:0;transform:translateX(-50%) translateY(8px)}';
  document.head.appendChild(css);

})();
